import React from 'react'
import ModalBody from './modal/modal-body'
import { contactList } from '@/data/contact'
import ProfileImage from '@/assets/images/profile.jpg'

type Props = {}

const WhoAmI = (props: Props) => {
    const chip = ["Computer Engineer", "Software Developer", "Full-Stack Developer", "Backend Developer"]
  return (
    <ModalBody>
        <div className='flex flex-col items-center justify-center gap-y-4 w-full '>
            <div
                style={{
                    backgroundImage: `url(${ProfileImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'top'
                }}
                className='w-24 h-24 md:w-28 md:h-28 rounded-full object-cover'
            />
            <div className='flex flex-col items-center gap-y-2 justify-center'>
                <h1 className='text-xl md:text-2xl font-bold'>Songwut Malisri</h1>
                <p className='text-xs md:text-sm text-gray-400'>(ทรงวุฒิ มะลิศรี)</p>
            </div>
            <div className='flex flex-row items-center flex-wrap justify-center gap-x-2 gap-y-2 w-full md:w-3/4'>
                {chip.map((chip) => (
                    <div key={chip} className='flex items-center gap-x-2 text-xs p-2 bg-blue-500/15 rounded-full text-gray-400 text-center'>
                        <div className='w-2 h-2 bg-blue-500 rounded-full' />
                        <span className=' text-center'>{chip}</span>
                    </div>
                ))}
            </div>
            <div className='text-xs md:text-sm text-gray-400 w-full md:w-3/4 text-center'>
                <p>"I am a Computer Engineering student with a strong foundation in software development, problem-solving, and system design. With a growing interest in full-stack and backend development."</p>
            </div>
            <span className='text-xs text-blue-500'>Contact Me</span>
            <div className='flex flex-row items-center justify-center gap-x-2 w-full md:w-3/4'>
                {contactList.map((contact) => (
                    <a href={contact.href} key={contact.id} target='_blank' rel='noopener noreferrer' className='flex hover:translate-y-[-2px] transition-all duration-300 items-center justify-center gap-x-2'>
                        {contact.icon}
                    </a>
                ))}
            </div>
        </div>
    </ModalBody>
  )
}

export default WhoAmI